import { useDispatch, useSelector } from "react-redux";
import { getGroups, getSingleTankSensor } from "../../Api Methods/Api";
import { useLoaderData, useNavigate } from "react-router-dom";
import Stats2 from "../../components/UI/Stats/Stats2";
import classes from "./tankSensorEntity.module.css";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { SAMPLING_PERIOD_OPTIONS, POLARITY_OPTIONS, CONNECTION_DAY_OPTIONS } from "../../components/UI/Cards/Automations/VirutalSources/TankSensor/tankSensorOptions";

const TankSensorEntity = () => {

    const _sensor = useLoaderData();
    const sensor = _sensor[0]
    console.log(sensor);
    localStorage.removeItem('DeviceUUID')

    //  {
    //   id: '0867074081567338',
    //   ullage: 1,
    //   tank_height: 150,
    //   accelerometer_orientation: 9,
    //   battery_percentage: 99,
    //   firmware: '2.7',
    //   hardware: '05',
    //   last_seen: '2026-09-11T08:54:01.909Z',
    //   rtc_hour: 20,
    //   rtc_min: 41,
    //   rtc_sec: 19,
    //   dynamic_alarm_status_1: 0,
    //   dynamic_alarm_status_2: 0,
    //   static_alarm_status_1: 0,
    //   static_alarm_status_2: 0,
    //   static_alarm_status_3: 0,
    //   static_1_hysteresis: 20,
    //   static_2_hysteresis: 20,
    //   static_3_hysteresis: 20,
    //   static_1_polarity: 'lower',
    //   static_2_polarity: 'lower',
    //   static_3_polarity: 'lower',
    //   dynamic_1_polarity: 'lower',
    //   dynamic_2_polarity: 'lower',
    //   static_1_thresholdCm: 60,
    //   static_2_thresholdCm: 30,
    //   static_3_thresholdCm: 15,
    //   dynamic_1_rateOfChangeCm: 1,
    //   dynamic_2_rateOfChangeCm: 1,
    //   server_address: 'betaipio.m2mservices.mobi',
    //   server_port: 8081,
    //   log_interval_mins: 30,
    //   sampling_period: '1',
    //   connection_time_hour: 0,
    //   connection_time_min: 0,
    //   connection_days: 'mon,tue,wed,thu,fri,sat,sun',
    //   connection_time_end_hour: 23,
    //   connection_hour_frequency: 1,
    //   rcc_quality_score_filter: 2,
    //   rssi_quality_score_filter: 2,
    //   populated_on: '2026-09-10T20:41:20.000Z',
    //   sensorRowId: 89,
    //   sensorId: '0867074081567338',
    //   battery: 99,
    //   signal: 8,
    //   lastSeenAt: '2026-09-11T08:54:02.000Z',
    //   dateAdded: '2026-09-10T20:41:17.000Z',
    //   ownedByGID: null,
    //   billedToGID: null,
    //   billable: 1,
    //   firstInvoiceDate: null,
    //   billingFrequency: null,
    //   lastInvoiceDate: null,
    //   addedById: null,
    //   sensorStatus: 'online',
    //   sensorType: 10,
    //   customerBilledToGID: null,
    //   siteName: 'KNOWIO',
    //   online: 'YES',
    //   tag: 'Demo 456',
    //   subGroup: '',
    //   sensorName: '',
    //   virtualInput: '1',
    //   siteUUID: '9f2ecdc0-4cb7-407c-8c7b-e402f9f814ae',
    //   unlinked: 0
    // }

    const sensorID = sensor.id
    const ullage = sensor.ullage
    const tankHeight = sensor.tank_height
    const battery = sensor.battery_percentage
    const firmware = sensor.firmware
    const lastSeen = sensor.last_seen
    const dateAdded = sensor.dateAdded
    const ownedByGID = sensor.ownedByGID
    const billedToGID = sensor.billedToGID
    const billable = sensor.billable
    const dateOfHardwareInvoice = sensor.firstInvoiceDate
    const dateOfSaaSInvoice = sensor.lastInvoiceDate
    const billingFrequency = sensor.billingFrequency
    const customerBilledToGID = sensor.customerBilledToGID
    const usedByName = sensor.siteName
    const siteName = sensor.tag
    const serial = sensor.subGroup

    const [navigateToLinkedSite, setNavigateToLinkedSite] = useState(false);
    const [navigateToGroup, setNavigateToGroup] = useState(false);
    const [groups, setGroups] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const companyName = useSelector(state => state.auth.companyName);
    const isAllowed = companyName === "EyeSpyFX" || companyName === "KNOWIO";
    const isCustomerBillingAllowed = companyName === "EyeSpyFX" || companyName === "RE:SURE";

    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");
    const apiData = { token, client };

    const samplingPeriodLabel = (value) => SAMPLING_PERIOD_OPTIONS.find(o => o.value === Number(value))?.label || "Not set";
    const connectionDaysLabel = (value) => {
        if (!value) return "Not set";
        const days = value.split(",");
        return days.map(d => CONNECTION_DAY_OPTIONS.find(o => o.value === d)?.label || d).join(", ");
    };
    const polarityLabel = (value) => POLARITY_OPTIONS.find(o => o.value === value)?.label || value;

    // Owned by / billed to / customer billed to are stored as group IDs - resolve them against
    // the site's group list to show the group name instead, same as sensorEntity.js.
    const convertGroupIDToName = (groupID) => {
        let group = groups.find(group => group.id == groupID)
        let groupName = ""
        if (group) {
            groupName = group.name
        }
        return groupName
    }

    const staticAlarmValue = (thresholdCm, hysteresis, polarity, triggered) => {
        if (thresholdCm == null) return null;
        return `${polarityLabel(polarity)} than ${thresholdCm}cm (Revert tolerance ${hysteresis ?? 0}cm)${triggered ? " — Triggered" : ""}`;
    };

    const dynamicAlarmValue = (rateOfChangeCm, polarity, triggered) => {
        if (rateOfChangeCm == null) return null;
        return `${polarityLabel(polarity)} than ${rateOfChangeCm}cm between readings${triggered ? " — Triggered" : ""}`;
    };

    useEffect(() => {
        const GetGroups = async () => {
            const data = await getGroups(apiData, dispatch);
            setGroups(data);
        };
        GetGroups();
    }, []);

    useEffect(() => {
        if (navigateToLinkedSite && sensor.siteUUID) {
            navigate(`/Dashboard/SiteView/${sensor.siteUUID}`);
        }
    }, [navigateToLinkedSite]);

    useEffect(() => {
        if (navigateToGroup) {
            const groupClicked = groups.find(g => g.name === usedByName);
            if (groupClicked) {
                sessionStorage.setItem("groupClicked", groupClicked.name);
                sessionStorage.setItem("groupPath", groupClicked.group_path);
                sessionStorage.setItem("groupClickedID", groupClicked.id);
                navigate("/Dashboard/Groups/GroupSites/");
            }
        }
    }, [navigateToGroup]);

    return (
        <div className={classes.activtyPage_container}>
            <div className={classes.container}>
                <Stats2 title={"Sensor ID"} value={sensorID} isLoadingStats={false} isStatic={true} />

                {siteName && (
                    <Stats2 title={"Linked to"} value={siteName} isLoadingStats={false} isStatic={true} setNavigateToLinkedSite={setNavigateToLinkedSite} />
                )}

                {usedByName && (
                    <Stats2 title={"Used by"} value={usedByName} isLoadingStats={false} isStatic={true} setNavigateToGroup={setNavigateToGroup} />
                )}

                {sensor.sensorName && (
                    <Stats2 title={"Sensor name"} value={sensor.sensorName} isLoadingStats={false} isStatic={true} />
                )}

                {serial && (
                    <Stats2 title={"Serial number"} value={serial} isLoadingStats={false} isStatic={true} />
                )}

                <Stats2 title={"Firmware"} value={firmware || "Unknown"} isLoadingStats={false} isStatic={true} />

                <Stats2 title={"Battery"} value={battery != null ? `${battery}%` : "No data"} isLoadingStats={false} isStatic={true} />

                <Stats2
                    title={"Tank height"}
                    value={tankHeight != null ? `${tankHeight} cm` : "Not set"}
                    isLoadingStats={false}
                    isStatic={true}
                />

                <Stats2
                    title={"Ullage"}
                    value={ullage != null ? `${ullage} mm` : "No data"}
                    isLoadingStats={false}
                    isStatic={true}
                />

                {lastSeen && (
                    <Stats2 title={"Last updated"} value={format(new Date(lastSeen), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                )}

                {dateAdded && (
                    <Stats2 title={"Date linked"} value={format(new Date(dateAdded), "MMM do, yyyy - HH:mm")} isLoadingStats={false} isStatic={true} />
                )}

                {sensor.log_interval_mins != null && (
                    <Stats2 title={"Log interval"} value={`${sensor.log_interval_mins} min`} isLoadingStats={false} isStatic={true} />
                )}

                {sensor.sampling_period != null && (
                    <Stats2 title={"Sampling period"} value={samplingPeriodLabel(sensor.sampling_period)} isLoadingStats={false} isStatic={true} />
                )}

                {(sensor.connection_time_hour != null && sensor.connection_time_min != null) && (
                    <Stats2
                        title={"First connection time"}
                        value={`${String(sensor.connection_time_hour).padStart(2, "0")}:${String(sensor.connection_time_min).padStart(2, "0")} UTC`}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}

                {sensor.connection_days && (
                    <Stats2 title={"Connection days"} value={connectionDaysLabel(sensor.connection_days)} isLoadingStats={false} isStatic={true} />
                )}

                {sensor.rcc_quality_score_filter != null && (
                    <Stats2 title={"RCC quality score filter"} value={sensor.rcc_quality_score_filter} isLoadingStats={false} isStatic={true} />
                )}

                {sensor.rssi_quality_score_filter != null && (
                    <Stats2 title={"RSSI quality score filter"} value={sensor.rssi_quality_score_filter} isLoadingStats={false} isStatic={true} />
                )}

                {[1, 2, 3].map(i => {
                    const value = staticAlarmValue(
                        sensor[`static_${i}_thresholdCm`],
                        sensor[`static_${i}_hysteresis`],
                        sensor[`static_${i}_polarity`],
                        sensor[`static_alarm_status_${i}`] === 1
                    );
                    return value ? <Stats2 key={`static-${i}`} title={`Threshold alarm ${i}`} value={value} isLoadingStats={false} isStatic={true} /> : null;
                })}

                {[1, 2].map(i => {
                    const value = dynamicAlarmValue(
                        sensor[`dynamic_${i}_rateOfChangeCm`],
                        sensor[`dynamic_${i}_polarity`],
                        sensor[`dynamic_alarm_status_${i}`] === 1
                    );
                    return value ? <Stats2 key={`dynamic-${i}`} title={`Rate of change alarm ${i}`} value={value} isLoadingStats={false} isStatic={true} /> : null;
                })}

                {isAllowed && (
                    <Stats2
                        title={"Owned by"}
                        value={convertGroupIDToName(ownedByGID) || "Not set"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}

                {isAllowed && (
                    <Stats2
                        title={"Billable"}
                        value={billable == 1 ? "Yes" : "No"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}

                {(billable == 1 && isAllowed) && (
                    <Stats2
                        title={"Inniovate bill to"}
                        value={convertGroupIDToName(billedToGID) || "Not set"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}

                {isAllowed && (
                    <Stats2
                        title={"Billing frequency"}
                        value={billingFrequency ?? "Not set"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}

                {isAllowed && (
                    <Stats2
                        title={"Date of hardware invoice"}
                        value={dateOfHardwareInvoice ? format(new Date(dateOfHardwareInvoice), "dd/MM/yyyy") : "Not set"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}

                {isAllowed && (
                    <Stats2
                        title={"Date of 1st SaaS invoice"}
                        value={dateOfSaaSInvoice ? format(new Date(dateOfSaaSInvoice), "dd/MM/yyyy") : "Not set"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                )}
            </div>

            {isCustomerBillingAllowed && <p style={{ marginLeft: "2px", marginTop: "50px", fontWeight: "500", fontSize: "20px", color: "#808080" }}>Customer billing</p>}
            {isCustomerBillingAllowed && (
                <div className={classes.container}>
                    <Stats2
                        title={"RE:SURE bill to"}
                        value={convertGroupIDToName(customerBilledToGID) || "No"}
                        isLoadingStats={false}
                        isStatic={true}
                    />
                </div>
            )}
        </div>
    );
};

export default TankSensorEntity;

export async function tankSensorLoader({ params }) {
    const IMEI = params.IMEI;
    const token = localStorage?.getItem("token");
    const client = localStorage?.getItem("client");

    const response = await getSingleTankSensor({ token, client }, IMEI);
    console.log(response);
    return response.data;
}
